var map = {
	"./PartnerLogos/PwC.svg": 5945,
	"./PartnerLogos/TheCodex.svg": 1389,
	"./RH_21_Logo.svg": 3799,
	"./blob_1.svg": 8558,
	"./blob_2.svg": 7680,
	"./blob_3.svg": 4437,
	"./close-icon.svg": 7020,
	"./quote_box.svg": 974,
	"./star_1.svg": 649,
	"./star_2.svg": 3906,
	"./star_3.svg": 9830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1641;